import { render, staticRenderFns } from "./StaffSettings.vue?vue&type=template&id=5f00a4d7&scoped=true"
import script from "./StaffSettings.vue?vue&type=script&lang=js"
export * from "./StaffSettings.vue?vue&type=script&lang=js"
import style0 from "./StaffSettings.vue?vue&type=style&index=0&id=5f00a4d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00a4d7",
  null
  
)

export default component.exports